import React, { useContext, useEffect, useState } from "react";
import MainContext from "../../MainContext";
import MySideBar from "../component/MySideBar";
import css from "../content.module.css";
import ContentViewer from "../ContentViewer";
export default function PricePage() {
  const ctx = useContext(MainContext);
  useEffect(() => {
    ctx.getDataPrice();
  }, []);

  return (
    <ContentViewer
      title={ctx.state.dataPrice?.title}
      imgdata={ctx.state.dataPrice?.imgdata}
      content={ctx.state.dataPrice?.content}
    />
  );
}
